

import Contact from './contact.vue';
import MsgList from './msgList.vue';

export default {

    components: {
        MsgList,
        Contact
    },

    created() {
        let t = this;

    },
    activated() {
        let t = this;
    },
    methods: {
        syncUnread(options) {
            this.$refs.contact.syncUnread(options);
        },
        groupChange() {
            let t = this;
            t.$refs.contact.loadData();
            t.$refs.contact.$forceUpdate();
        },
        goGroup(item) {
            let t = this;
            t.employee = null;
            t.group = item;
            if (item.count > 0) {
                t.$eventBus.$emit('refresh-unread', true, -1);
            }
            item.count = 0;
            t.view = 'msgList';
            t.$emit('hideNav');
        },
        goEmployee(item) {
            let t = this;
            t.group = null;
            t.employee = item;
            if (item.count > 0) {
                t.$eventBus.$emit('refresh-unread', true, -1);
            }
            item.count = 0;
            t.view = 'msgList';
            t.$emit('hideNav');
        },
    },
    data() {
        return {
            group: null,
            employee: null,
            view: 'contact',
            dict: {
            },
            list: {

            },
        };
    },
};
